import React from "react";
import { Input } from "@/components/ui/input";

type Props = {
  email: string;
  setEmail: (email: string) => void;
  error?: string;
};

export const EmailInput: React.FC<Props> = ({ email, setEmail, error }) => (
  <div className="w-full">
    <Input
      type="email"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      placeholder="Enter your email"
      className={`h-12 px-6 border-2 ${error ? 'border-destructive' : 'border-border'} transition-all duration-200`}
    />
    {error && (
      <p className="text-destructive text-xs mt-1 animate-in fade-in slide-in-from-top-1 duration-200">
        {error}
      </p>
    )}
  </div>
);
